/**
 * Utility function: Determines scroll direction based on current and previous scroll positions.
 * @param {object} options - Configuration options.
 * @param {number} [options.previousScrollPosition=0] - Previous scroll position.
 * @param {number} [options.offset=0] - Minimum scroll difference required to detect a change.
 * @param {number} [options.pageBottomThreshold=1] - Offset from the bottom of the page.
 * @returns {{ direction: 'up' | 'down', lastScrollPosition: number } | undefined}
 */
export const scrollDirection = ({ previousScrollPosition = 0, offset = 0, pageBottomThreshold = 1 } = {}) => {
    const scrollTop = window.pageYOffset || document.scrollingElement.scrollTop;

    if (Math.abs(previousScrollPosition - scrollTop) < offset) return;

    let lastScrollPosition = previousScrollPosition || window?.scrollDirection?.lastScrollPosition || 0,
        direction = scrollTop > lastScrollPosition ? 'down' : 'up';

    // Force 'up' direction if at the bottom of the page
    if (scrollTop + window.innerHeight + pageBottomThreshold >= document.documentElement.scrollHeight) {
        direction = 'up';
    }

    return {
        direction,
        lastScrollPosition: Math.max(0, scrollTop),
    };
};
